module.exports = __webpack_public_path__ + "static/media/HighPerformance_02.c497f665.svg";